module.exports = __webpack_public_path__ + "img/part_tab2_box2_2.de5663fe.jpg";